import React, { useRef } from 'react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { AgGridReact } from 'ag-grid-react';
import useBalancesColDefs from './useBalancesColDefs';
import useBalanceDatasource from './useBalancesDatasource';
import clearingAccountsOpts from '../options';
import useOnCellClick from '../useOnCellClick';
import useContext from '../useClearingAccountsContext';

export const BALANCES_GRID_NAME = 'balancesGrid';
const BALANCES_GRID_VERSION = 1;

const BalancesGrid = () => {
  const gridRef = useRef<AgGridReact>(null);
  const {
    gridVisible,
    initialGridSettings,
    onStateUpdated,
  } = useAgGridCommon({
    gridName: BALANCES_GRID_NAME,
    version: BALANCES_GRID_VERSION,
  });

  const onCellClicked = useOnCellClick({ balances: true });
  const context = useContext();
  const colDefs  = useBalancesColDefs({
    initialState: initialGridSettings,
    gridRef,
  });
  const datasource = useBalanceDatasource();

  return (
    <div className="ag-theme-quartz">
      {gridVisible ? (
        <AgGridReact
          ref={gridRef}
          columnDefs={colDefs}
          gridOptions={clearingAccountsOpts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          rowModelType="serverSide"
          serverSideDatasource={datasource}
          context={context}
          onCellClicked={onCellClicked}
        />
      ) : null}
    </div>
  );
};

export default BalancesGrid;
